import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = {
  key: 0,
  class: "gfu-product-card__tag-container _ml-3"
}
const _hoisted_3 = {
  class: "_line-clamp-2",
  "data-qa": "column-header-props:Name"
}
const _hoisted_4 = {
  class: "gfu-bt--caption _fw-n",
  "data-qa": "column-header-props:Price"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_badge = _resolveComponent("base-badge")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_image = _resolveComponent("base-image")
  const _component_context_link = _resolveComponent("context-link")

  return (_openBlock(), _createElementBlock("th", {
    ref: "row",
    class: _normalizeClass(['gfu-product-comparison-table-column-header', $options.themeClass]),
    style: _normalizeStyle(`left: ${$options.formattedOffset}`),
    "data-qa": $props.dataQa
  }, [
    _createVNode(_component_context_link, _mergeProps($options.contextLinkProps, { class: "gfu-product-comparison-table-column-header__link" }), {
      default: _withCtx(() => [
        ($props.isFeatured)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_base_badge, { class: "gfu-product-card__tag" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.FeaturedProductBadge), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]))
          : _createCommentVNode("v-if", true),
        ($props.icon)
          ? (_openBlock(), _createBlock(_component_base_icon, {
              key: 1,
              name: $props.icon,
              size: "3x",
              class: "gfu-product-comparison-table-column-header__icon"
            }, null, 8 /* PROPS */, ["name"]))
          : (_openBlock(), _createBlock(_component_base_image, {
              key: 2,
              src: $props.imageUrl,
              alt: $props.productName,
              width: 108,
              height: 108
            }, null, 8 /* PROPS */, ["src", "alt"])),
        _createElementVNode("div", {
          class: _normalizeClass(['_flexcol _pa-1 _grow-1 _jc-sb', $options.textAlignmentClass])
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString($props.productName), 1 /* TEXT */),
          _createElementVNode("span", _hoisted_4, _toDisplayString($options.formattedPrice), 1 /* TEXT */)
        ], 2 /* CLASS */)
      ]),
      _: 1 /* STABLE */
    }, 16 /* FULL_PROPS */)
  ], 14 /* CLASS, STYLE, PROPS */, _hoisted_1))
}